<template>
    <div>
        <div class="main-content__row">
            <p>Вы успешно записались в путешествие {{ currentEvent.name }}.</p>

            <p>Что дальше: вам на почту придет письмо со всей информацией о точке старта, контактами на месте и
                советами,
                что взять с собой в путешествие. Если вдруг вам не придет письмо (и в спаме его нет), пожалуйста,
                напишите нам на allo@silavetra.com, отправим вам повторно.</p>

            <p>За 2-3 недели мы добавим вас в чат с вашим капитаном и командой.</p>

            <p>Хороших приключений &#9973;</p>
            <!--<template v-if="currentEvent.links && currentEvent.links.length">
              <p>А пока можете ознакомиться с полезными материалами:</p>
              <ul class="main-content__downloand-list">
                <li class="main-content__downloand-list-item" v-for="link in currentEvent.links" v-bind:key="link.name">
                  <a target="_blank" v-bind:href="link.link">
                    {{ link.name }}
                </a></li>
              </ul>
            </template>-->
            <span class="success" v-if="blankSaved"> Анкета успешно отправлена</span>

        </div>
        <div class="form main-content__form" v-if="!blankSaved">
            <div class="main-content__row">
                <p>
                    Если у вас есть пара минут, пожалуйста, ответьте на несколько вопросов ниже.
                </p>
                <div class="field form__input-wrap">
                    <label class="form__label">
                        Вы едете в путешествие в компании?
                    </label>
                </div>
                <div class="form__radio-wrap">
                    <label class="form__radio-label">
                        <input class="form__radio" type="radio" name="friends" v-model="blank.self" v-bind:value="true">
                        <div class="form__radio-text-before"></div>
                        <div class="form__radio-text">
                            Я еду один / одна
                        </div>
                    </label>

                    <label class="form__radio-label">
                        <input class="form__radio" type="radio" name="friends" v-model="blank.self"
                               v-bind:value="false">
                        <div class="form__radio-text-before"></div>
                        <div class="form__radio-text">
                            Я еду c друзьями / близкими
                        </div>
                    </label>

                    <div class="field form__input-wrap field-friends" v-show="!self">
                        <label class="form__label">
                            Введите имена друзей
                        </label>
                        <textarea class="form__input" type="text" name="friends"
                                  placeholder="Имена и фамилии друзей (чтобы мы знали, что вы едете вместе)"
                                  v-model="blank.friends"/>
                    </div>
                </div>

                <div class="form__radio-wrap">
                    <label class="form__label">
                        Откуда вы о нас узнали?
                    </label>
                    <label for="how_find_friends" class="form__radio-label">
                        <input type="checkbox" class="form__radio" id="how_find_friends" value="от друзей"
                               v-model="blank.howFinds.friends"/>
                        <div class="form__radio-text-before"></div>
                        <div class="form__radio-text">
                            от друзей
                        </div>
                    </label>
                    <label for="how_find_instagram" class="form__radio-label">
                        <input type="checkbox" class="form__radio" id="how_find_instagram" value="из инстаграма"
                               v-model="blank.howFinds.instagram"/>
                        <div class="form__radio-text-before"></div>
                        <div class="form__radio-text">
                            из инстаграма
                        </div>
                    </label>
                    <label for="how_find_facebook" class="form__radio-label">
                        <input type="checkbox" class="form__radio" id="how_find_facebook" value="из фейсбука"
                               v-model="blank.howFinds.facebook"/>
                        <div class="form__radio-text-before"></div>
                        <div class="form__radio-text">
                            из фейсбука
                        </div>
                    </label>
                    <label for="how_find_other" class="form__radio-label">
                        <input type="checkbox" class="form__radio" id="how_find_other" value="другое"
                               v-model="blank.howFinds.other"/>
                        <div class="form__radio-text-before"></div>
                        <div class="form__radio-text">
                            другое
                        </div>
                    </label>
                </div>


                <div class="form__radio-wrap">
                    <div class="field form__input-wrap">
                        <label class="form__label">
                            Ваш яхтенный опыт
                        </label>
                    </div>
                    <label class="form__radio-label" for="zero">
                        <input class="form__radio" type="radio" id="zero" name="practice" v-model="blank.practice"
                               value="zero">
                        <div class="form__radio-text-before"></div>
                        <div class="form__radio-text">
                            нулевой
                        </div>
                    </label>
                    <label class="form__radio-label" for="middle">
                        <input class="form__radio" type="radio" id="middle" name="practice" v-model="blank.practice"
                               value="middle">
                        <div class="form__radio-text-before"></div>
                        <div class="form__radio-text">
                            1-3 похода
                        </div>
                    </label>
                    <label class="form__radio-label" for="high">
                        <input class="form__radio" type="radio" id="high" name="practice" v-model="blank.practice"
                               value="high">
                        <div class="form__radio-text-before"></div>
                        <div class="form__radio-text">
                            более 3 походов
                        </div>
                    </label>
                </div>
                <div class="field form__input-wrap">
                    <label class="form__label">
                        Ссылка на ваш профиль в соцсетях
                    </label>
                    <input type="text" class="form__input" name="activity-field"
                           placeholder="Ссылка" v-model="blank.social">
                </div>
                <div class="button-wrap">
                    <button class="form__button button" v-bind:class="isError ? 'button_disabled' : ''"
                            value="Отправить" @click="submit">
                        Отправить
                    </button>
                    <span class="button_disabled-before" v-if="isError"> Необходимо заполнить все поля</span>

                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapState, mapMutations, mapActions} from 'vuex'

    /* global WecanGtm */
    export default {
        mounted() {
            let self = this
            setTimeout(function () {
                self.sendInfoToGtm()
            }, 2000)
        },
        beforeMount() {
            if (this.$router.currentRoute.params.eventId) {
                this.setCurrentEventId(this.$router.currentRoute.params.eventId);
                this.getEvent();
            }
        },
        data: function () {
            return {
                emptyBlank: true
            }
        },
        watch: {
            self: function () {
                this.blank.friends = '';
            }
        },
        methods: {
            sendInfoToGtm: function () {
                WecanGtm.purchase(
                    this.order.id,
                    window.location.hostname,
                    this.order.sum,
                    this.order.certificate_code?? this.order.promocode,
                    this.currentEvent.name,
                    this.currentEvent.direction_id,
                    process.env.VUE_APP_GTM_CATEGORY,
                    this.order.person_count,
                    'N/A',
                    this.currentEvent.currency
                )
            },
            submit: function () {
                if (!this.isError) {
                    this.saveBlank(this.blank);
                }
            },
            ...mapActions([
                'saveBlank',
                'getEvent'
            ]),
            ...mapMutations([
                'setCurrentEventId'
            ])
        },
        computed: {
            isError: function () {
                let errors = 0;

                for (let a in this.blank) {
                    if (a != 'friends') {
                        if (a != 'self' && !this.blank[a]) {
                            errors++;
                        }
                    } else {
                        if (!this.blank[a] && !this.blank['self']) {
                            errors++;
                        }
                    }
                }

                return errors;
            },
            self: function () {
                return this.blank.self;
            },
            ...mapState([
                'currentEvent',
                'blankSaved',
                'blank',
                'order',
            ])
        }
    }
</script>
<style>
    .field-friends {
        padding-top: 20px;
    }

    .success {
        color: green;
        font-size: 14px;
    }
</style>
